import dateHelper from '$$dateFormatsHelper';

/**
 * Specifies the drag date in the timeline area
 * @param instance
 * @returns {function(*): string}
 */
export default instance => (date) => {
  const durationData = instance.config.durationData;
  const dateFormat = durationData.mode === 'hour' ? dateHelper.getDateFormatForGanttGrid() : dateHelper.getDateFormat();

  return instance.date.date_to_str(dateFormat)(date);
};
